<script setup lang="ts">
import SidebarItem from "@/components/MyStudents/Navigation/SidebarItem.vue";
import type { NavigationSectionProps } from "@/components/OperationsApp/components/Navigation/types.ts";

defineOptions({ name: "HomeSection" });

const props = withDefaults(defineProps<NavigationSectionProps>(), {
  showHiddenNav: false,
  showHeader: false,
});

const emit = defineEmits(["menu-item-clicked"]);

const handleMenuItemClick = () => {
  emit("menu-item-clicked");
};
</script>

<template>
  <div data-testid="operations-home-section">
    <div v-if="showHeader" class="mt-4" data-testid="home-title">
      <h2
        class="font-montserrat font-bold text-university-primary mb-2"
      >
        Home
      </h2>
      <hr class="border-t border-gray-475 mb-2" />
    </div>
    <ul class="space-y-2" data-testid="home-list">
      <SidebarItem
        v-if="showHiddenNav"
        text="Dashboard"
        :router-link="{
          name: 'operations-dashboard'
        }"
        data-test-id="operations-item-home"
        @menu-item-clicked="handleMenuItemClick"
        mui-icon-name="browse_activity"
        :enable-selected-links="true"
      />
    </ul>
  </div>
</template>

<style scoped>

</style>
